import React from 'react';

import Link from '@/components/switchback/Link/Link';
import { IPageCategory } from '@/services/getHelpPageData';

import css from './ArticleCategories.module.css';

interface IArticleCategoriesProps {
  articleCategories: IPageCategory[];
}

const ArticleCategories: React.FC<IArticleCategoriesProps> = ({ articleCategories }) => {
  if (!articleCategories || !articleCategories.length) {
    return null;
  }
  return (
    <ul className={css.links}>
      {articleCategories.map(category => {
        return (
          <li key={category.id}>
            <Link href={`/help/category/${category.slug}/${category.id}`} className={css.item}>
              <a className="font-normal body-sm">{category.name}</a>
            </Link>
            {category.count && <span className="pl-1 body-sm">({category.count})</span>}
          </li>
        );
      })}
    </ul>
  );
};
export default ArticleCategories;
